import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

const Register: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [accessCode, setAccessCode] = useState('');
  const [error, setError] = useState('');
  const [codeStatus, setCodeStatus] = useState<'idle' | 'checking' | 'valid' | 'invalid'>('idle');
  const [isLoading, setIsLoading] = useState(false);
  const { register, validateCode } = useAuth();
  const navigate = useNavigate();

  const handleCodeChange = async (code: string) => {
    setAccessCode(code);
    if (code.length >= 6) {
      setCodeStatus('checking');
      try {
        const result = await validateCode(code);
        setCodeStatus(result.valid ? 'valid' : 'invalid');
      } catch {
        setCodeStatus('idle');
      }
    } else {
      setCodeStatus('idle');
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (codeStatus !== 'valid') {
      setError('Wprowadź prawidłowy kod dostępu');
      return;
    }

    if (password.length < 6) {
      setError('Hasło musi mieć co najmniej 6 znaków');
      return;
    }

    setIsLoading(true);

    try {
      await register(email, password, name, accessCode);
      navigate('/');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <span className="auth-logo">🎓</span>
          <h1>YouCanLearn.pl</h1>
          <p>Utwórz nowe konto</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="auth-error">{error}</div>}

          <div className="form-group">
            <label htmlFor="accessCode">Kod dostępu *</label>
            <div className="input-with-status">
              <input
                type="text"
                id="accessCode"
                value={accessCode}
                onChange={(e) => handleCodeChange(e.target.value.toUpperCase())}
                placeholder="XXXXXXXX"
                required
                maxLength={10}
                className={codeStatus === 'valid' ? 'valid' : codeStatus === 'invalid' ? 'invalid' : ''}
              />
              {codeStatus === 'checking' && <span className="status-icon">⏳</span>}
              {codeStatus === 'valid' && <span className="status-icon valid">✓</span>}
              {codeStatus === 'invalid' && <span className="status-icon invalid">✗</span>}
            </div>
            <small>Kod otrzymasz od administratora</small>
          </div>

          <div className="form-group">
            <label htmlFor="name">Imię</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Twoje imię"
              required
              autoComplete="name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="twoj@email.pl"
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Hasło</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Minimum 6 znaków"
              required
              minLength={6}
              autoComplete="new-password"
            />
          </div>

          <button type="submit" className="auth-button" disabled={isLoading || codeStatus !== 'valid'}>
            {isLoading ? 'Rejestracja...' : 'Zarejestruj się'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Masz już konto? <Link to="/login">Zaloguj się</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Register;

